/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDLink from "components/MDLink";

import routes from "routes";

function isValidRoute(path, routesArr = routes) {
  return routesArr.some(route => {
    if (route.route) {
      // Replace :params with regex to match dynamic segments
      const pattern = "^" + route.route.replace(/:[^/]+/g, "[^/]+") + "$";
      if (new RegExp(pattern).test(path)) return true;
    }
    // Recursively check collapse subroutes
    if (route.collapse && Array.isArray(route.collapse)) {
      if (isValidRoute(path, route.collapse)) return true;
    }
    return false;
  });
}

function Breadcrumbs({ icon, title, route, light = false }) {
  const routesArr = route.slice(0, -1);

  let cumulative = "";

  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <MDLink to="/">
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDTypography>
        </MDLink>
        {routesArr.map((el, idx) => {
          cumulative += `/${el}`;
          const valid = isValidRoute(cumulative);
          if (valid) {
            return (
              <MDLink to={cumulative} key={el}>
                <MDTypography
                  component="span"
                  variant="button"
                  fontWeight="regular"
                  textTransform="capitalize"
                  color={light ? "white" : "dark"}
                  opacity={light ? 0.8 : 0.5}
                  sx={{ lineHeight: 0 }}
                >
                  {el}
                </MDTypography>
              </MDLink>
            );
          }
          return (
            <MDTypography
              key={el}
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el.replace("-", " ")}
            </MDTypography>
          );
        })}
        <MDTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replace("-", " ")}
        </MDTypography>
      </MuiBreadcrumbs>
      <MDTypography
        fontWeight="bold"
        textTransform="capitalize"
        variant="h6"
        color={light ? "white" : "dark"}
        noWrap
      >
        {title.replace("-", " ")}
      </MDTypography>
    </MDBox>
  );
}


export default Breadcrumbs;
